export const LOG_LEVEL_OPTIONS = ['INFO', 'ERROR', 'WARNING'] as const;
// using (typeof LOG_LEVEL_OPTIONS)[number] throws error when using ts-to-zod generator
export type LogLevel = 'INFO' | 'ERROR' | 'WARNING';

export type RunLog = {
  timestamp: string;
  logLevel: LogLevel;
  details: string;
};
